import type {
  ChainType,
  Connection,
  EVMChain,
  Evaluate,
  SolanaChain,
  SolanaWalletClient,
} from '@particle-network/connector-core';
import type { WalletClient } from 'viem';
import type { Config } from '../createConfig';
import { getSolanaWalletClient } from './getSolanaWalletClient';
import { getWalletClient } from './getWalletClient';

export type MapWalletClientParamers = {
  connections: Connection[];
  config: Config;
};

export type WalletClientType<chainType extends ChainType = EVMChain> = chainType extends EVMChain
  ? WalletClient
  : SolanaWalletClient;

export type Wallet = Readonly<
  Evaluate<
    {
      getWalletClient: <chainType extends ChainType = EVMChain>() => WalletClientType<chainType>;
    } & Connection
  >
>;

export type MapWalletClientReturnType = Wallet[];

export const mapWalletClient = async (parameters: MapWalletClientParamers): Promise<MapWalletClientReturnType> => {
  const { connections, config } = parameters;
  const wallets: Wallet[] = [];
  for (const connection of connections) {
    if (!connection.connector.walletConnectorType) {
      continue;
    }
    if (connection.connector.chainType === 'evm') {
      const client = await getWalletClient(config, { connector: connection.connector });
      const wallet = {
        ...connection,
        getWalletClient: <chainType extends ChainType = EVMChain>() => client as WalletClientType<chainType>,
      };
      wallets.push(wallet);
    } else {
      const client = await getSolanaWalletClient(config, { connector: connection.connector });
      const wallet = {
        ...connection,
        getWalletClient: <chainType extends ChainType = SolanaChain>() => client as WalletClientType<chainType>,
      };
      wallets.push(wallet);
    }
  }
  return wallets;
};
